var map = {
	"./cityDelivery.png": "2862",
	"./cityDelivery1.png": "20fa",
	"./drone.png": "6792",
	"./drone1.png": "b5c5",
	"./electricalTools.png": "f0f9",
	"./electricalTools1.png": "c1be",
	"./heavyTransport.png": "ca13",
	"./heavyTransport1.png": "ea61",
	"./highSpeedMotorcycle.png": "c23a",
	"./lightPassengerVehicle.png": "374e",
	"./lightPassengerVehicle1.png": "abe7",
	"./logisticsFreight.png": "1378",
	"./logisticsFreight1.png": "ef89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "acbe";